module.exports = __webpack_public_path__ + "static/media/tan_7350.png.531edabc.webp";